import profilePicture from '../Assets/Images/profile-picture-placeholder.svg';

const isAvatar = (informations) => {
  if (informations.discord.avatar) {
    return `https://cdn.discordapp.com/avatars/${informations.discord.id}/${informations.discord.avatar}.png`;
  }
  return profilePicture;
};

export default isAvatar;
